import { useGetAdminPermissions } from "@entities/admin/lib/hooks/useGetAdminPermissions";
import { Divider, Flex, Tree } from "antd";
import type { TreeDataNode, TreeProps } from "antd";
import { useEffect, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import { Button } from "@shared/ui/Button";
import hash from "object-hash";
import { useUpdateAdmin } from "@entities/admin";
import { ToastService } from "@shared/lib/services";
import { useGetPermissionGroups } from "@entities/permissionGroups/lib/hooks";
import { TextWithTooltip } from "@shared/ui/TextWithTooltip";
import { PermissionGroup } from "@shared/lib/types/permissions";

interface Props {
  selectedInitialPermissions: string[];

  permissionGroups: PermissionGroup[];
}

export function PermissionCard({
  selectedInitialPermissions,
  permissionGroups,
}: Props) {
  const { adminPermissions } = useGetAdminPermissions();

  const [selectedPermissions, setSelectedPermissions] = useState<string[]>(
    selectedInitialPermissions
  );

  // const generateHash = (arr: string[]) => hash(arr.sort());
  // const isSaveDisabled = useMemo(() => {
  //   return (
  //     generateHash(selectedInitialPermissions) ===
  //     generateHash(selectedPermissions)
  //   );
  // }, [selectedInitialPermissions, selectedPermissions]);

  const onCheck: TreeProps["onCheck"] = (checkedKeys, info) => {
    setSelectedPermissions(
      (checkedKeys as string[]).filter(
        (item) =>
          item !== "admin" && item !== "brand" && !item.startsWith("group-")
      )
    );
  };

  if (!adminPermissions) {
    return <></>;
  }

  const treeData: TreeDataNode[] = [
    {
      title: <span>Admin</span>,
      key: "admin",
      selectable: false,
      children: adminPermissions.admin.map((perm) => ({
        title: perm,
        key: perm,
        selectable: false,
      })),
    },
    {
      title: <span>Brand</span>,
      key: "brand",
      selectable: false,
      children: adminPermissions.brand.map((perm) => ({
        title: perm,
        key: perm,
        selectable: false,
      })),
    },
    ...(permissionGroups || [])?.map((group) => ({
      title: <TextWithTooltip text={group.name} limit={30} />,
      key: `group-${group._id}`,
      selectable: false,
      children: group.permissions.map((perm) => ({
        title: perm,
        key: perm,
        selectable: false,
      })),
    })),
  ];

  return (
    <div className={styles.card}>
      <Flex vertical gap={6}>
        <div className={styles.permTitle}>Permission Groups</div>
        <Flex vertical gap={2}>
          {permissionGroups.map((group) => (
            <div key={group._id}>
              <TextWithTooltip text={group.name} limit={30} />
            </div>
          ))}
        </Flex>

        {/* <Divider style={{ margin: 0 }} />
        <div>
          <div className={styles.permTitle}>Granular Permissions</div>

          <div className={styles.permContent}>
            <Tree
              disabled
              checkable
              checkedKeys={selectedPermissions}
              onCheck={onCheck}
              treeData={treeData}
              selectable={false}
            />
          </div>
        </div> */}
      </Flex>
    </div>
  );
}
